<template>
    <div>
        <Header/>
        <router-view></router-view>
        <div v-if="$route.name === 'home' || $route.name === 'home.invited'" class="privacy">
            <router-link to="privacy">Privacy</router-link>
        </div>
    </div>
</template>

<script>
    import Header from "./components/Layout/Header";
    export default {
        components: {
            Header,
        }
    }
</script>

<style lang="scss">
    @import 'node_modules/bootstrap/scss/bootstrap';
    @import 'node_modules/bootstrap-vue/src/index.scss';
    $primary-color: #AC5EF8;
    $secondary-color: #7822CC;
    $wrapper-color: #BE88F4;
    $text-color: #fff;
    $orange-color: #FF843E;
    html, body {
        height: 100%;
        width: 100%;
    }
    body {
        background-color: $primary-color;
        color: $text-color;
    }
    .btn-primary {
        background-color: $secondary-color;
        &:hover, &:active {
            background-color: $primary-color;
            border: none;
        }
    }
    .btn-secondary {
        background-color: $wrapper-color;
        border: none;
        &:hover, &:active {
            background-color: $secondary-color;
            border: none;
        }
    }
    .btn-start {
        background-color: $orange-color;
        min-height: 4rem;
        min-width: 35%;
        font-size: 2rem;
        border-radius: 0.5rem;
        border: none;
        text-align: center;
        color: #fff;
        &:hover, &:active {
            background-color: #d36d33;
            color: #fff;
            border: none;
        }
    }
    .privacy {
        position: absolute;
        bottom: 0;
        right: 0;
        a {
            color: #fff;
            text-decoration: underline;
        }
    }
</style>
